import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Model } from 'survey-core';
import "survey-core/survey-core.min.css";
import { SurveyService } from '../survey/survey.service';
import{Router,NavigationEnd, ActivatedRoute} from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-survey-preview-component',
  templateUrl: './survey-preview-component.component.html',
  styleUrls: ['./survey-preview-component.component.css']
})
export class SurveyPreviewComponentComponent implements OnInit {
survey:any;
model: Model;
reqDefId:number;
requestNumber='';
  constructor(private surveyService: SurveyService,private route: ActivatedRoute,private location: Location) { }
   /*ngOnInit(): void {
    this.route.params.subscribe(params => {
            this.requestNumber=params['requestNumber'];
    })    
 //var reqNumber =  '1912.1421100';//'1911.1419104';
    this.surveyService.SurveyPreviewData(this.requestNumber).subscribe(data => {
      const surveyJson = data[0].formData;
      const completedData =   JSON.parse(data[0].jsonData);
      this.survey = new Model(surveyJson);   
      this.survey.data = completedData;

      this.model = this.survey;

  this.model.readOnly = true;
  this.model.showPreviewBeforeComplete = true;
  this.model.previewText = "Review your answers";
  this.model.showPreview();

   this.survey.onAfterRenderSurvey.add((sender, options) => {
      const editButton = document.querySelector('.sv_edit_button');
      if (editButton instanceof HTMLElement) {
        editButton.style.display = 'none';
      }
    });


    });
  }*/

   goBack(): void {   
    let len= this.requestNumber.length;    
    var reqNo = this.requestNumber.substring(5,len);
    if (document.baseURI.indexOf("localhost") != -1) {     
      window.location.href ="http://localhost:3000/rh/main/request/" + reqNo;
    }
    else if (document.baseURI.indexOf("isrtest") != -1) {      
       window.location.href ="https://rhtest.enn.ericsson.net/rh/main/request/" + reqNo;
    }
    else if (document.baseURI.indexOf("isr") != -1) {     
       window.location.href = "https://rh.enn.ericsson.net/rh/main/request/" + reqNo;
    }
    //this.location.back();  // Use Location service to go back
  }

  ///--- Below code is for future reference
  ngOnInit(): void {
    // Your survey JSON definition   
     this.route.params.subscribe(params => {
            this.requestNumber=params['requestNumber'];
    })    
    this.surveyService.SurveyPreviewData(this.requestNumber).subscribe(data => {
      const surveyJson = data[0].formData;
      const completedData =   JSON.parse(data[0].jsonData);
      this.survey = new Model(surveyJson);   
    
    this.survey.data = completedData;    

    this.survey.readOnly = true;
    this.survey.showPreviewBeforeComplete = true;
    this.survey.previewText = "Review your answers";         
    
     this.survey.showPreview();
      this.model= this.survey; 
        
    });


   /* // Create a Survey model
   // const surveyModel = new Survey.Model(surveyJson);
 //const surveyModel = new Model(surveyJson);
 this.survey = new Model(surveyJson);   
    // Set completed data
    const completedData = {
      question1: "John Doe",
      question2: "john.doe@example.com"
    };

    this.survey.data = completedData;
    //surveyModel.data = completedData;

    // Render the survey
    //Survey.SurveyNG.render("surveyContainer", { model: surveyModel });
    //surveyModel.render("surveyContainer");
    this.model= this.survey;    */
  }

}
